import { WebGLUniformBufferBase } from "./WebGLUniformBufferBase";
import { WebGLUniformBufferDescriptor } from "./WebGLUniformBufferDescriptor";
export class WebGLSubUniformBuffer extends WebGLUniformBufferBase {
    upload() {
        this.needUpload && this.bufferBlock.needUpload();
    }
    bind(location) {
        let buffer = this.bufferBlock.cluster.buffer;
        buffer.bindBufferRange(location, this.bufferBlock.offset, this.bufferBlock.size);
    }
    constructor(name, uniformMap, mgr, data) {
        super();
        this.name = name;
        this.manager = mgr;
        this.data = data;
        this.uniformMap = uniformMap;
        let descriptor = new WebGLUniformBufferDescriptor(name);
        uniformMap.forEach(uniform => {
            descriptor.addUniform(uniform.id, uniform.uniformtype, uniform.arrayLength);
        });
        descriptor.finish(this.manager.byteAlign / 4);
        let bufferSize = descriptor.byteLength;
        this.descriptor = descriptor;
        this.size = bufferSize;
        this.bufferBlock = mgr.getBlock(bufferSize, this);
        this.needUpload = true;
    }
    updateOver() {
        this.needUpload = false;
    }
    clearGPUBufferBind() {
    }
    notifyGPUBufferChange(info) {
        this.offset = this.bufferBlock.offset;
        this.needUpload = true;
        this.descriptor.uniforms.forEach(uniform => {
            let size = uniform.viewByteLength / uniform.dataView.BYTES_PER_ELEMENT;
            let offset = uniform.offset + this.bufferBlock.offset;
            uniform.view = new uniform.dataView(this.bufferBlock.cluster.data, offset, size);
        });
        this.needUpload = true;
    }
    destroy() {
        this.name = null;
        this.data = null;
        this.uniformMap = null;
        this.descriptor.destroy();
        this.descriptor = null;
        this.manager.freeBlock(this.bufferBlock);
        this.destroyed = true;
    }
}
